module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1172.d6e92acf.png";